import { Navigate, Outlet, Route, Routes } from 'react-router';
import { SalesPage } from '../../pages/sales/SalesPage';
import { OrdersPage } from '../../pages/orders/OrdersPage';
import { CardsPage } from '../../pages/cards/CardsPage';
import { LoginpPage } from '../../pages/login/LoginPage';

function hasAuthToken(): boolean {
	console.log(document.cookie);
	return document.cookie.split('; ').some((cookie) => cookie.startsWith('auth-key='));
}

function AuthRoute({ inverted }: { inverted?: boolean }) {
	if (inverted ? hasAuthToken() : !hasAuthToken()) {
		return <Navigate to={inverted ? '/orders' : '/login'} replace />;
	}

	return <Outlet />;
}

export function RouteProvider() {
	return (
		<Routes>
			<Route element={<AuthRoute inverted={true} />}>
				<Route path="/login" element={<LoginpPage />} />
			</Route>
			<Route element={<AuthRoute />}>
				<Route path="/orders" element={<OrdersPage />} />
				<Route path="/sales" element={<SalesPage />} />
				<Route path="/cards" element={<CardsPage />} />
			</Route>
			<Route path="*" element={<Navigate to="/login" replace />} />
		</Routes>
	);
}
